import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=00088c2d"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
script.render = render

export default script